export const BASE_URL = window.origin;
export const API_URL = '';
export const SHEETS_API_URL = 'https://sheets.googleapis.com/v4/spreadsheets/';
export const API_KEY = "AIzaSyDgXNamDcyAjiee8_f5W4snn0gn9HoXNhU";

/** Mismo libro que el resto de la web; hoja "Usuarios" con usuario en B y contraseña en C desde la fila 1 */
export const SPREADSHEET_ID = '1FyBkFmdLO8BeNdmDohYRvAh_nJP1jsdsEZ_rPYm8m1s';
/** Datos del dashboard: primera fila = encabezados; ajusta el nombre de hoja en Sheets si hace falta */
export const INVERSIONES_SHEET = 'Inversiones';